function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.113 0C4.584 0 .102 4.477.102 10s4.482 10 10.011 10c5.53 0 10.012-4.477 10.012-10S15.643 0 10.113 0zm-.001 4c.65 0 1.197.54 1.202 1.192a1.212 1.212 0 01-1.208 1.206 1.212 1.212 0 01-1.192-1.202 1.212 1.212 0 011.198-1.195zm1.203 10.729c-.001.61-.343 1.076-.89 1.226-.77.211-1.504-.366-1.511-1.198-.007-.88-.002-1.758-.002-2.638v-.34c0-.98-.006-1.958.002-2.938.007-.878.794-1.443 1.606-1.164.477.163.788.61.794 1.155.006.486.001.973.001 1.46 0 1.479.002 2.958 0 4.437z",
  fill: "#F6A224"
});

function SvgWarningTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none"
  }, props), _ref);
}

export default SvgWarningTransfer;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/warning_transfer.svg
// module id = 1339
// module chunks = 10